import React, { useState } from "react";
import { Container, Row, Col, Card, Button, Form } from "react-bootstrap";
import "./membercss/MemberInfo.css";
import './membercss/BasicInformation.css';
import Avatars from './Avatars';
import useTranslations from '../transalation/TranslationUtils';
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { createMember, getMemberDetail, setCreateLoading, setMemberPageFormData, setPageFormToMemberData, setSimpleData, setSimpleDataToMemberData, updateMember } from "app/redux/slices/rdxMemberSlice";
import { DEFAULT_IP, MODE_EDIT, MODE_UNKNOWN } from "app/utils/constant";
import { useNavigate } from "react-router-dom";
import { DatePicker } from "@mui/x-date-pickers";
import { FormControlLabel, Switch, TextField } from "@mui/material";

function BasicInformation() {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { basicinfo, savechaneg, showErrMsg, unlockAcct } = useTranslations();
    const [error, setError] = useState(null);
    const [successMessage, setSuccessMessage] = useState(null);
    const [birthdayError, setBirthdayError] = useState(null);

    const translations = useTranslations();
    const editOtherBasicInfo = useSelector((state) => state.rdxMember?.editOtherBasicInfo || {});
    const formMap = useSelector((state) => state.rdxMember?.basicInfoFormMap || {});
    const memberEditMode = useSelector((state) => state.rdxMember?.memberEditMode || MODE_UNKNOWN);
    const memberEditData = useSelector((state) => state.rdxMember?.memberEditData || {});

    const handleDateChange = (key, newVal) => {
        let isValidDate = false;
        if (Object.prototype.toString.call(newVal) === "[object Date]") {
            if (isNaN(newVal)) { }
            else {
                isValidDate = true;
            }
        }
        
        //set empty to trigger disable save button
        if (!isValidDate) {
            setBirthdayError(null); // Clear any existing error
            let data = {
                data: { key: key, val: "" },
                projection: "basicInfoFormMap"
            };
            dispatch(setMemberPageFormData(data));
            return;
        }

        // Extract year and month directly from the Date object to avoid timezone issues
        let year = newVal.getFullYear();
        let month = String(newVal.getMonth() + 1).padStart(2, '0');
        let value = `${year}-${month}-01`;
        
        let canUpdateFormVal = false;
        if ("account_birth" == key) {
            canUpdateFormVal = true;

            // Validate the birthday and set error message if invalid
            const validation = validateBirthday(value);
            if (!validation.isValid && validation.error) {
                setBirthdayError(validation.error);
            } else {
                setBirthdayError(null); // Clear error if valid
            }

            // Calculate age if date of birth is changed
            let age = calculateAge(value);
            let data = {
                data: { key: "f_age", val: age },
                projection: "basicInfoFormMap"
            };
            dispatch(setMemberPageFormData(data));
        } else {
            canUpdateFormVal = true;
        }

        if (canUpdateFormVal) {
            let data = {
                data: { key: key, val: value },
                projection: "basicInfoFormMap"
            };
            dispatch(setMemberPageFormData(data));
        }
    };

    const handleInputChange = (e, key, item) => {
        const { value } = e.target;

        let canUpdateFormVal = false;
        if ("account_phone" == key) {
            // Ensure mobile are numeric and max 10 digits
            if (/^\d{0,10}$/.test(value)) {
                canUpdateFormVal = true;
            }
        } else if ("member_id" == key) {
            // Ensure member ID are numeric and max 8 digits
            if (/^\d{0,8}$/.test(value)) {
                canUpdateFormVal = true;
            }
        } else if ("card_ref" == key) {
            // Ensure card ref is alphanumeric and max 5 characters
            if (/^[a-zA-Z0-9]{0,5}$/.test(value)) {
                canUpdateFormVal = true;
            }
        } else {
            canUpdateFormVal = true;
        }

        if (canUpdateFormVal) {
            let data = {
                data: { key: key, val: value },
                projection: "basicInfoFormMap"
            };
            dispatch(setMemberPageFormData(data));
        }
    };

    const handleSwitchChange = () => {
        let data = {
            data: !editOtherBasicInfo.is_lock,
            projection: "editOtherBasicInfo",
            path: "is_lock"
        }
        dispatch(setSimpleData(data));
    }

    const onBasicInfoPicChanged = (newPic) => {
        let picUrl = DEFAULT_IP + newPic.replace("/assets", "").replace(DEFAULT_IP, "");
        // console.log("on avatar changed:", picUrl);

        let data = {
            data: { key: "account_avatar", val: picUrl },
            projection: "basicInfoFormMap"
        };
        dispatch(setMemberPageFormData(data));
    }

    const validateBirthday = (dob) => {
        if (!dob) return { isValid: false, error: "" };

        // Parse the date string manually
        const dobParts = dob.split('-');
        if (dobParts.length !== 3) {
            return { isValid: false, error: "Invalid date format. Please use YYYY-MM-DD." };
        }
        
        const birthYear = parseInt(dobParts[0]);
        const birthMonth = parseInt(dobParts[1]);
        const birthDay = parseInt(dobParts[2]);
        
        // Validate parsed values
        if (isNaN(birthYear) || isNaN(birthMonth) || isNaN(birthDay)) {
            return { isValid: false, error: "Invalid date. Please enter valid numbers." };
        }

        // Year validation (1800-2100)
        if (birthYear < 1800) {
            return { isValid: false, error: "Birth year cannot be earlier than 1800." };
        }
        if (birthYear > 2100) {
            return { isValid: false, error: "Birth year cannot be later than 2100." };
        }

        // Month validation (1-12)
        if (birthMonth < 1 || birthMonth > 12) {
            return { isValid: false, error: "Birth month must be between 1 and 12." };
        }

        // Day validation (1-31)
        if (birthDay < 1 || birthDay > 31) {
            return { isValid: false, error: "Birth day must be between 1 and 31." };
        }

        // Check for valid days in specific months
        const daysInMonth = new Date(birthYear, birthMonth, 0).getDate();
        if (birthDay > daysInMonth) {
            const monthNames = ['', 'January', 'February', 'March', 'April', 'May', 'June',
                              'July', 'August', 'September', 'October', 'November', 'December'];
            return { isValid: false, error: `${monthNames[birthMonth]} ${birthYear} only has ${daysInMonth} days.` };
        }

        // Future date validation
        const today = new Date();
        const birthDate = new Date(birthYear, birthMonth - 1, birthDay);
        if (birthDate > today) {
            return { isValid: false, error: "Birth date cannot be in the future." };
        }

        // Check if date is too far in the future (more reasonable check)
        const currentYear = today.getFullYear();
        if (birthYear > currentYear) {
            return { isValid: false, error: `Birth year cannot be later than ${currentYear}.` };
        }

        return { isValid: true, error: null };
    };

    const calculateAge = (dob) => {
        if (!dob) return "";

        // Use validation function to check if date is valid
        const validation = validateBirthday(dob);
        if (!validation.isValid) {
            return ""; // Return empty for invalid dates, error will be shown separately
        }

        // Parse the validated date string
        const dobParts = dob.split('-');
        const birthYear = parseInt(dobParts[0]);
        const birthMonth = parseInt(dobParts[1]) - 1; // Month is 0-indexed in Date constructor
        const birthDay = parseInt(dobParts[2]);

        const today = new Date();
        let years = today.getFullYear() - birthYear;

        // Adjust if the current date is before the birth date in the current year
        const isBeforeBirthdayThisYear =
            today.getMonth() < birthMonth ||
            (today.getMonth() === birthMonth && today.getDate() < birthDay);

        if (isBeforeBirthdayThisYear) {
            years -= 1;
        }

        return (`${years} ${years !== 1 ? '' : ''}`);
    };

    const phonePass = () => {
        let result = !(!formMap["account_phone"].val || formMap["account_phone"].val.length > 10);
        return result;
    };

    const emailPass = () => {
        let result = true;

        // Email validation: simple regex for basic validation
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!formMap["account_email"].val || !emailRegex.test(formMap["account_email"].val)) {
            result = false;
        }
        return result;
    };

    const checkInvalid = (key) => {
        let result = false;

        if ("account_name" == key) {
            if (!formMap[key]["val"]) {
                result = true;
            }
        } else if ("account_phone" == key ||
            "member_id" == key ||
            "account_email" == key) {
            if (!phonePass() &&
                !formMap["member_id"]["val"] &&
                !emailPass()
            ) {
                result = true;
            }
        } else if ("account_birth" == key) {
            // Check if birthday field has validation error
            if (birthdayError) {
                result = true;
            }
        }

        return result;
    };

    const canSaveChnages = () => {
        let phonePassVal = phonePass();
        let emailPassVal = emailPass();
        let birthdayIsValid = !birthdayError && formMap["account_birth"].val;

        return (phonePassVal || emailPassVal || formMap["member_id"].val)
            &&
            (formMap["account_name"].val)
            &&
            (formMap["account_gender"].val)
            &&
            birthdayIsValid
            &&
            (MODE_UNKNOWN != memberEditMode);
    }

    const handleSubmit = async (e) => {
        e.preventDefault();

        // if (!phonePass) {
        //     setError("Phone number should not exceed 10 digits.");
        //     return;
        // }

        if (formMap["member_id"].val.length > 8) {
            setError("Member ID should not exceed 8 digits.");
            return;
        }

        // if (!emailPass()) {
        //     setError("Please enter a valid email address.");
        //     return;
        // }

        // Joined Date validation: must not be a future date
        // const today = new Date().toISOString().split("T")[0];
        // if (inputValues.input9 > today) {
        //     setError("Joined Date cannot be a future date.");
        //     return;
        // }

        if (MODE_EDIT == memberEditMode) {
            let sendData = {
                "account_id": memberEditData.account_id
            };
            for (const key in formMap) {
                let formItem = formMap[key];
                if (!formItem.ignore) {
                    sendData[key] = formMap[key].val;
                }
            }
            sendData.is_lock = editOtherBasicInfo.is_lock;
            dispatch(updateMember(sendData, (isSuccess, data) => {
                if (isSuccess) {
                    dispatch((dispatch, getState) => {
                        dispatch(setPageFormToMemberData({ formMap: formMap }));

                        const latestEditMemberData = getState().rdxMember.memberEditData;
                        let rData = {
                            data: { ...latestEditMemberData, ...editOtherBasicInfo },
                            projection: "self",
                            base: memberEditData
                        };
                        dispatch(setSimpleDataToMemberData(rData));
                    });

                    alert("Basic information saved successfully!");
                } else {
                    alert(showErrMsg(data));
                }
            }));
        } else {
            let sendData = {};
            for (const key in formMap) {
                let formItem = formMap[key];
                if (!formItem.ignore) {
                    sendData[key] = formMap[key].val;
                }
            }
            dispatch(setCreateLoading({ loading: true }));
            dispatch(createMember(sendData, (isSuccess, data) => {
                if (isSuccess) {
                    alert("Basic information create successfully!");

                    navigate("/member/memberinfo?account_id=" + data.data.account_id);
                    dispatch(getMemberDetail(data.data.account_id, (isSuccess, data) => {
                        if (!isSuccess) {
                            alert(showErrMsg(data));
                            navigate("/member/membermanagement");
                        }
                    }));
                } else {
                    dispatch(setCreateLoading({ loading: false }));
                    alert(showErrMsg(data));
                }
            }));
        }
    };


    return (
        <Container fluid>
            <Row>
                <Col md={12}>
                    <Card className="mt-0 border-0">
                        <Card.Body>
                            <Avatars editable={true} onAvatarChanged={onBasicInfoPicChanged} initAvatar={formMap["account_avatar"].val} />
                            <br />
                            <Form onSubmit={handleSubmit}>
                                <Row>
                                    <h5 className="basicinfo">{basicinfo()}</h5>
                                    {Object.keys(formMap).map(key => (
                                        <React.Fragment key={key}>
                                            {"input" == formMap[key].type ? (
                                                <Col md={6}>
                                                    <Form.Group controlId={key} className={`floating-label-group ${checkInvalid(key) ? "m-invalid-form" : ""}`}>
                                                        <Form.Control
                                                            disabled={formMap[key].ignore}
                                                            type="text"
                                                            name={key}
                                                            value={formMap[key]["val"]}
                                                            onChange={(event) => handleInputChange(event, key, formMap[key])}
                                                            className="floating-input basicinfoinput"
                                                        />
                                                        <Form.Label className="floating-label basicinfolabel">{translations[formMap[key].label]()}</Form.Label>
                                                    </Form.Group>
                                                </Col>
                                            ) : "select" == formMap[key].type ? (
                                                <Col md={6}>
                                                    <Form.Group controlId={key} className="floating-label-group">
                                                        <Form.Select
                                                            disabled={formMap[key].ignore}
                                                            name={key}
                                                            value={formMap[key]["val"]}
                                                            onChange={(event) => handleInputChange(event, key, formMap[key])}
                                                            className="floating-input"
                                                        >
                                                            {formMap[key].options.map(({ label, value }) => (
                                                                <option key={label} value={value}>{translations[label]()}</option>
                                                            ))}
                                                        </Form.Select>
                                                        <Form.Label className="floating-label basicinfolabel">{translations[formMap[key].label]()}</Form.Label>
                                                    </Form.Group>
                                                </Col>
                                            ) : "datepicker" == formMap[key].type ? (
                                                <Col md={6}>
                                                    <Form.Group controlId={key} className={`floating-label-group ${checkInvalid(key) ? "m-invalid-form" : ""}`}>
                                                        <DatePicker
                                                            label={translations[formMap[key].label]()}
                                                            InputLabelProps={{ shrink: true }}
                                                            value={(() => {
                                                                const dateStr = formMap[key]["val"];
                                                                if (!dateStr) return null;
                                                                
                                                                // Parse the date string manually to avoid timezone issues
                                                                const parts = dateStr.split('-');
                                                                if (parts.length >= 2) {
                                                                    const year = parseInt(parts[0]);
                                                                    const month = parseInt(parts[1]) - 1; // Month is 0-indexed
                                                                    // Create date at noon to avoid timezone issues
                                                                    return new Date(year, month, 15, 12, 0, 0, 0);
                                                                }
                                                                return null;
                                                            })()}
                                                            onChange={(val) => handleDateChange(key, val)}
                                                            views={['year', 'month']}
                                                            format="yyyy-MM"
                                                            openTo="month"
                                                            renderInput={(params) => (
                                                                <TextField 
                                                                    {...params} 
                                                                    inputProps={{ ...params.inputProps, readOnly: true }}
                                                                    error={checkInvalid(key)}
                                                                />
                                                            )}

                                                            sx={{
                                                                width: "100%"
                                                            }}

                                                        />
                                                        {key === "account_birth" && birthdayError && (
                                                            <div className="text-danger mt-1" style={{ fontSize: '0.875rem' }}>
                                                                {birthdayError}
                                                            </div>
                                                        )}
                                                    </Form.Group>
                                                </Col>
                                            ) : (<React.Fragment></React.Fragment>)}
                                        </React.Fragment>
                                    ))}
                                </Row>
                                <Row>
                                    <Col>
                                        <h5 className="basicinfo mt-3">
                                            {unlockAcct()}
                                            <FormControlLabel
                                                control={
                                                    <Switch
                                                        disabled={!memberEditData.is_lock}
                                                        checked={editOtherBasicInfo.is_lock}
                                                        onChange={handleSwitchChange}
                                                        color="primary"
                                                        className="ms-3"
                                                    />
                                                }
                                                label=""
                                            />
                                        </h5>
                                    </Col>
                                </Row>
                                <Row className="mt-2">
                                    <Col>
                                        <Button variant="primary" type="submit" className="me-2 instructorphoto"
                                            disabled={!canSaveChnages()}>
                                            {savechaneg()}
                                        </Button>
                                        {/* <Button variant="outline-primary" onClick={() => setInputValues({})} className="canslebtn">
                                            {cancel()}
                                        </Button> */}
                                    </Col>
                                </Row>

                                {error && <p className="text-danger mt-3">{error}</p>}
                                {successMessage && <p className="text-success mt-3">{successMessage}</p>}
                            </Form>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </Container >
    );
}

export default BasicInformation;